import React from 'react';
import HeroHe from '../components/HeroHe';
import AboutSectionHe from '../components/AboutSectionHe';
import FeaturesHe from '../components/FeaturesHe';
import DriverWaitlistHe from '../components/DriverWaitlistHe';
import DriverFAQHe from '../components/DriverFAQHe';
import FooterHe from '../components/FooterHe';

const HomePageHe: React.FC = () => {
  return (
    <>
      <HeroHe />
      <AboutSectionHe />
      <FeaturesHe />
      <div id="waitlist">
        <DriverWaitlistHe />
      </div>
      <DriverFAQHe />
      <FooterHe />
    </>
  );
};

export default HomePageHe;
